import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';

import { ICrisisActions, IThunkDeleteCrisisAllocation } from '../types';

const onDeleteCrisisAllocation: IThunkDeleteCrisisAllocation = thunk(
  async ({ setCrisisAllocation }: Actions<ICrisisActions>, { clinicId, id }) => {
    await api.crisis.deleteCrisisAllocation(clinicId, id);

    setCrisisAllocation(null);
  },
);

export default onDeleteCrisisAllocation;
